import formatCurrency from "@/utils/formatCurrency";

const SectionTotal = ({ label, amount, colorClass = "teal" }) => {
  const colorStyles = {
    teal: "bg-teal-50 border-teal-200 text-teal-700",
    blue: "bg-blue-50 border-blue-200 text-blue-700",
    green: "bg-green-50 border-green-200 text-green-700",
    yellow: "bg-yellow-50 border-yellow-200 text-yellow-700",
    red: "bg-red-50 border-red-200 text-red-700"
  };
  const style = colorStyles[colorClass] || colorStyles.teal;
  const [bg, border, text] = style.split(' ');

  return (
    <div className={`flex items-center justify-between py-3 px-4 rounded-lg border ${bg} ${border}`}>
      <span className={`font-semibold ${text}`}>{label}</span>
      <span className={`font-bold ${text.replace('700', '600')} text-lg`}>₹{formatCurrency(amount)}</span>
    </div>
  );
};

export default SectionTotal;
